import {createDialog, createLoadingDialog} from './dialog';
import {generatePDFUrl, triggerDownload} from './helpers';
let $ = window.jQuery;

export function displayNoPreviewWarningDialog(action: PDFAction, entryIds: number[], layoutId: string, cb: ActionCallback, cancelCb = () => {
}): void {
    if (!hasUnpreviewedCertificates(entryIds)) {
        cb(layoutId);
        return;
    }

    const dialog = createDialog(`<h2>${PDFGenerator.text_preview_header}</h2>`, `
        <p>${entryIds.length === 1 ? PDFGenerator.text_preview_warning_single : PDFGenerator.text_preview_warning_multiple}</p>
        <div class="gf-pdf-modal-footer">
            <button class="gf-pdf-button -secondary continue-wo-preview-selected -centered" type="submit">${PDFGenerator.text_continue_without_preview}</button>
            <button class="gf-pdf-button open-preview-selected -centered" type="submit">${PDFGenerator.text_open_preview}</button>
            <button style="display: none;" class="gf-pdf-button continue-print -centered" type="submit">${PDFGenerator.text_continue}</button>
        </div></div></form>`, {
        showCloseButton: true,
        closeButtonText: PDFGenerator.text_cancel,
    });
    dialog[0].showModal();
    dialog.on('click', '.continue-wo-preview-selected,.continue-print', function (e) {
        e.preventDefault();
        cb(layoutId);
        dialog.remove();
        markAsPreviewed(entryIds);
    }).on('click', '.open-preview-selected', function (e) {
        const downloadDialog = createLoadingDialog( '<h2>Generating preview...</h2>');
        const downloadUrl = generatePDFUrl(action, entryIds, layoutId, true);
        const downloaded = triggerDownload(downloadUrl);

        downloaded.then(() => {
            $('.continue-print').show();
            $('.continue-wo-preview-selected').hide();
            $('.open-preview-selected').addClass('-secondary');
            markAsPreviewed(entryIds);
            downloadDialog.remove();
        }).catch((e) => {
            downloadDialog.showCloseButton(true).setContent(`<p>${PDFGenerator.text_failed_to_download_file}</p> <p><a class="gf-pdf-button -centered" href="${downloadUrl}" target="_blank">${PDFGenerator.text_download_file}</a></p>`);
        });
    });
}



function hasUnpreviewedCertificates(entryIds: number[]) {
    const previewed = localStorage.getItem('gf_pdf_previewed') || '[]';
    const previewedIds = JSON.parse(previewed);

    for (let id of entryIds) {
        if (!previewedIds.includes(id)) {
            return true;
        }
    }

    return false;
}

function markAsPreviewed(entryIds: number[]) {
    const previewed = localStorage.getItem('gf_pdf_previewed') || '[]';
    const previewedIds = JSON.parse(previewed);

    for (let id of entryIds) {
        if (!previewedIds.includes(id)) {
            previewedIds.push(id);
        }
    }

    localStorage.setItem('gf_pdf_previewed', JSON.stringify(previewedIds));
}